/**
 * @flow
 * @relayHash cbf75224a93bafba39faf7690aef7ea3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TaskStatusUpdateInput = {|
  id: string,
  name: string,
  color: string,
|};
export type UpdateTaskStatusMutationVariables = {|
  data: TaskStatusUpdateInput
|};
export type UpdateTaskStatusMutationResponse = {|
  +updateTaskStatus: {|
    +id: string
  |}
|};
export type UpdateTaskStatusMutation = {|
  variables: UpdateTaskStatusMutationVariables,
  response: UpdateTaskStatusMutationResponse,
|};
*/


/*
mutation UpdateTaskStatusMutation(
  $data: TaskStatusUpdateInput!
) {
  updateTaskStatus(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "TaskStatusUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateTaskStatus",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "TaskStatusModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateTaskStatusMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateTaskStatusMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateTaskStatusMutation",
    "id": null,
    "text": "mutation UpdateTaskStatusMutation(\n  $data: TaskStatusUpdateInput!\n) {\n  updateTaskStatus(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '77f04933c6c5c8bb7df9cf4b0109f8bf';
module.exports = node;
